const rowdata = [
  { title: 'Steven Lee', pic: './public/images/ab1.jpg', items: [
    'Firm has a experience of 33 years in the industry and that proved to be a great asset for my bussiness.'
  ]},
  { title: 'Miranda Adams', pic: './public/images/ab2.jpg', items: [
    'Chachan and Lath have always been a solution to all my taxation and legal assistance related problems.',
  ]},
  { title: 'Thomas Hardy', pic: './public/images/ab3.jpg', items: [
    'Chachan and Lath always have solutions for all my seed funding, share broking, taxation related problems.',
  ]},
];
export default rowdata;



// WEBPACK FOOTER //
// ./src/ClientsPage/rowdata.js